export default function ContentBox({ children, flip }) {
  return <div className={`content-box ${flip ? "flip" : ""}`}>{children}</div>
}
